import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../store';
import { GeneralActions } from '../store/entities/general/general.actions';
import { IAutoCompleteItem } from '../models/autoComplete';
import { IDynamicList } from '../store/entities/general/type';

type Options = {
  types: IAutoCompleteItem[];
  statuses: IAutoCompleteItem[];
};

export const useVoucherDynamicOptions = (includeStatuses = true): Options => {
  const dispatch = useAppDispatch();
  const { appLanguage, voucherTypes, voucherStatuses } = useAppSelector(
    (s) => s.general
  );

  useEffect(() => {
    dispatch(GeneralActions.getVoucherTypes());
    if (includeStatuses) {
      dispatch(GeneralActions.getVoucherStatuses());
    }
  }, [dispatch, includeStatuses]);

  const types = useMemo<IAutoCompleteItem[]>(() => {
    return (voucherTypes || []).map((t: IDynamicList) => ({
      id: t.id,
      label: appLanguage === 'hebrew' ? t.nameHE : (t.nameEN ?? ''),
    }));
  }, [voucherTypes, appLanguage]);

  const statuses = useMemo<IAutoCompleteItem[]>(() => {
    return (voucherStatuses || []).map((s: IDynamicList) => ({
      id: s.id,
      label: appLanguage === 'hebrew' ? s.nameHE : (s.nameEN ?? ''),
    }));
  }, [voucherStatuses, appLanguage]);

  return { types, statuses };
};

export default useVoucherDynamicOptions;
